/* eslint-disable @typescript-eslint/no-unused-vars */
import { useState, useRef, useEffect } from "react";
import { IStatusProps } from "./Models";
import useImage from "use-image";
import ConflictSvg from "@/assets/icons/conflictSvg.svg";
import { Group, Rect } from "react-konva";
import { Html } from "react-konva-utils";
import { TOTAL_TILE_COLUMN } from "./BufferStart";
import { TimeFunction } from "@/common/datetime/TimeFunction";

export const ConflictStatus = ({
  x,
  widthState,
  heightState,
  totalTile,
  height,
  isHaveBuffer,
  overlappingEvents
}: IStatusProps): JSX.Element => {
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
  const [widthElement, setWidthElement] = useState<number>(0);
  const [image] = useImage(ConflictSvg);
  const timeoutRef = useRef<number>();

  const handleMouseEnter = (e: any) => {
    const stage = e.target.getStage();
    const { x, y } = stage.getPointerPosition();
    const stageBox = stage.container().getBoundingClientRect();

    const position = {
      x: x + stageBox.left,
      y: y + stageBox.top - 30,
    };

    setTooltipPosition(position);

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      setTooltipVisible(true);
    }, 300);
  };

  const handleMouseMove = (e: any) => {
    if (!tooltipVisible) return;

    const stage = e.target.getStage();
    const { x, y } = stage.getPointerPosition();
    const stageBox = stage.container().getBoundingClientRect();

    const position = {
      x: x + stageBox.left,
      y: y + stageBox.top - 30,
    };

    setTooltipPosition(position);
  };

  const handleMouseLeave = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setTooltipVisible(false);
  };

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const positionTooltip = (): React.CSSProperties => {
    const padding = 10;
    const tooltipWidth = 300;
    const tooltipHeight = 200;

    let left = tooltipPosition.x - tooltipWidth / 2;
    if (left + tooltipWidth > window.innerWidth - padding) {
      left = window.innerWidth - tooltipWidth - padding;
    }
    if (left < padding) {
      left = padding;
    }

    let top = tooltipPosition.y;
    if (top < padding) {
      top = tooltipPosition.y + 60;
    }
    if (top + tooltipHeight > window.innerHeight - padding) {
      top = window.innerHeight - tooltipHeight - padding;
    }

    return {
      left,
      top,
    };
  };

  const TooltipContent = () => {
    const lines: string[] = [];
    if (overlappingEvents) {
      overlappingEvents.forEach(event => {
        lines.push(`${TimeFunction.dateTimeFormatter(event.start, "HH:mm").toString()} - ${TimeFunction.dateTimeFormatter(event.end, "HH:mm").toString()} ${event.subject}`);
      });
    }
    return lines.join('<br />');
  };

  return (
    <Group>
      <Rect
        x={x}
        height={height + 2}
        y={heightState - height + 3.1}
        width={(totalTile * widthState) / TOTAL_TILE_COLUMN}
        fillPatternImage={image}
        stroke="rgba(196, 49, 75, 1)"
        cornerRadius={isHaveBuffer ? 0 : 3}
        onMouseEnter={handleMouseEnter}
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
      />
      <Html
        divProps={{
          style: {
            position: "fixed",
            left: 0,
            top: 0,
            width: "100vw",
            height: "100vh",
            pointerEvents: "none",
            userSelect: "none",
          },
        }}
      >
        {tooltipVisible && (
          <div
            style={{
              position: "fixed",
              backgroundColor: "rgba(0, 0, 0, 0.8)",
              color: "#fff",
              padding: "4px 8px",
              borderRadius: "3px",
              fontSize: "11px",
              zIndex: 9999,
              whiteSpace: "normal",
              overflow: "hidden",
              maxWidth: "300px",
              wordBreak: "break-word",
              pointerEvents: "none",
              boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
              ...positionTooltip(),
            }}
            dangerouslySetInnerHTML={{ __html: TooltipContent() }}
          />
        )}
      </Html>
    </Group>
  );
};
